export * from '@primeuix/themes/lara/button';
export { default } from '@primeuix/themes/lara/button';
